import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { FilterService } from 'src/app/shared/services/filter.service';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-add-holiday',
    templateUrl: './add-holiday.component.html',
    styleUrls: ['./add-holiday.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddHolidayComponent implements OnInit {

	@Input() project?: any;
	@Input() holiday: any;
	@Input() duplicate: boolean = false;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	loading: boolean = false;
	formData: any = {
		'id': '',
		'date': '',
		'date_from': '',
		'date_to': '',
		'type': 'holliday',
		'description': '',
		'country_id': '',
		'all_years': ''
	}
	countries: any[] = [];
	projects: any[] = [];

	error: string;

	submitForm() {
		this.loading = true;
		this.adjustForm();
		this._pS.saveHoliday(this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		);
	}

	adjustForm() {
		this.formData.date_from = this.formData.date;
		this.formData.date_to = this.formData.date;
	}

	close() {
		this.closeView.emit()
	}

	fillForm() {
		if (!this.duplicate) {
			this.formData.id = this.holiday.id;
		}
		this.formData.description = this.holiday.description;
		this.formData.date = this.holiday.date;
		this.formData.country_id = this.holiday.country_id;
		this.formData.all_years = this.holiday.all_years;
	}

	loadData() {
		this.loading = true;
		this._pS.getCalendarEventData(this.project ? this.project.id : null).subscribe(
			(data: any) => {
				this.countries = data.countries;
				this.projects = data.projects || [];
				this.loading = false;
			}
		)
	}

	constructor(
		private _pS: ProjetcsService,
		public _gS: GlobalService,
		private _fS: FilterService) { }

	ngOnInit() {
		if (this.holiday) {
			this.fillForm();
		}
		this.loadData();
	}

}
